export default "__VITE_ASSET__CPggw5iT__"